import { apiLoja } from '@/services/api';
import {
    CONFIGURATIONPLAN_EXHIBITION_SET,
    CONFIGURATIONPLAN_EXHIBITION_LOADING,
    CONFIGURATIONPLAN_EXHIBITION_LOADED
} from '../actionTypes';

export const setConfiguratioPlanTypes = (configurationExhibition) => ({
    type: CONFIGURATIONPLAN_EXHIBITION_SET,
    payload: configurationExhibition,
});

export const loadingConfigurationPlanExhibition = () => ({
    type: CONFIGURATIONPLAN_EXHIBITION_LOADING,
});

export const loadedConfigurationPlanExhibition = () => ({
    type: CONFIGURATIONPLAN_EXHIBITION_LOADED,
});

export const fetchAllConfigurationPlanExhibition = () => {
    return (dispatch) => {
        dispatch(loadingConfigurationPlanExhibition());

        apiLoja
            .get(`/PlanoConfiguracaoExibicao`)
            .then((data) => {
                dispatch(setConfiguratioPlanTypes(data.data));
                dispatch(loadedConfigurationPlanExhibition());
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.log('error comming', error);
            });
    };
};